var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"config":_vm.config,"active-stat":_vm.activeStat}}),_vm._v(" "),_vm._l((_vm.config.statistics),function(statistic){return (_vm.activeStat.stat == statistic.stat)?_c('statistic',{key:statistic.stat,attrs:{"statistic":statistic,"active-stat":_vm.activeStat}}):_vm._e()})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5503ee0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/statistics-super-commissions/index.vue
// module id = PJFs
// module chunks = 0